import React from "react"
import { Link } from "react-router-dom"
import "../../assets/css/common.css"
import { t } from '../../components/i18n/i18n'
import { usePageLocale } from '../../components/i18n/usePageLocale'
import back from "../../assets/images/elements/aboutHeader.jpg";
import articlePdf from "../../resources/5-whoweare.pdf"
import article_img from "../../assets/images/articles/5_full.jpeg"

export const Article5WhoWeAre = () => {
    const ready = usePageLocale('article5');
    if (!ready) return <div style={{ padding: '60px', textAlign: 'center', color: '#999' }}>•••</div>;
    return (

        <section className='text_container_light'>
            <div className='container_100'>
                {/* Верхній блок з заголовком (як у About) */}
                <div className='backImg15'>
                    <img src={back} alt='' />
                    <div className='text_container_dark_15'>
                        <div className='h1_15'>{t("resourceArticle5Title")}</div>
                    </div>
                </div>

                <br />

                <div className='container boxItems'>
                    {/* Кнопка повернення */}
                    <Link to='/resources' style={{textDecoration: 'none', color: '#777'}}>
                        {t("resourceBackToList")}
                    </Link>
                    <br /><br />

                    <div className='article_grid'>
                        {/* ЛІВА КОЛОНКА: Метадані та Анотація */}
                        <div>
                            <h2 className='menuColor'>{t("resourceArticle5Title")}</h2>

                            <p>{t("resourceArticle5Author")}</p>

                            <div style={{ marginTop: '10px' }}>
                                <a
                                    href={articlePdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="pdf-download-link"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: '#b22222',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>📄</span>
                                    {t("resourceArticleDownloadOriginal")}
                                </a>
                            </div>

                            <hr />
                            <br/>

                            <img
                                src={article_img}
                                alt="Хто ми один одному"
                                className="article-img"
                            />

                            <h3 className='menuColor'>{t("resourceArticle5Sec1Title")}</h3>

                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P1_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P1_2") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle5Sec2Title")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P2_1") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle5Sec3Title")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P3_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P3_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P3_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P3_4") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle5Sec4Title")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P4_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P4_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P4_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P4_4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P4_5") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle5Sec5Title")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P5_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P5_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P5_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P5_4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P5_5") }} /></p>

                        </div>

                        {/* ПРАВА КОЛОНКА: Основний зміст */}
                        <div>

                            <h3 className='menuColor'>{t("resourceArticle5Sec6Title")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P6_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P6_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P6_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P6_4") }} /></p>

                            <br/>
                            <h3 className='menuColor'>{t("resourceArticle5Sec7Title")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P7_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P7_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P7_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P7_4") }} /></p>

                            <br/>
                            <h3 className='menuColor'>{t("resourceArticle5Sec8Title")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P8_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P8_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P8_3") }} /></p>
                            <ul className="article-list">
                                <li dangerouslySetInnerHTML={{ __html: t("resourceArticle5P8List1") }} />
                                <li dangerouslySetInnerHTML={{ __html: t("resourceArticle5P8List2") }} />
                                <li dangerouslySetInnerHTML={{ __html: t("resourceArticle5P8List3") }} />
                                <li dangerouslySetInnerHTML={{ __html: t("resourceArticle5P8List4") }} />
                                <li dangerouslySetInnerHTML={{ __html: t("resourceArticle5P8List5") }} />
                            </ul>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P8_4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5P8_5") }} /></p>

                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle1BibliographyHeader")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle5Bibliography") }} /></p>

                            <hr />
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '10px' }}>
                                {t("resourceArticle5Copyright")}
                            </p>
                            <br/>

                        </div>
                    </div>
                </div>
                <br />
            </div>
        </section>
    )
}
